/**
 * pages.config.ts - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import AdminAmdEngine from './pages/AdminAmdEngine';
import AdminCallingProvider from './pages/AdminCallingProvider';
import AdminNotifications from './pages/AdminNotifications';
// ADR-024 — TeamManagement supersedes the legacy AdminCallers + AdminClients pages.
// They handled two separate concerns (callers and "clients" — actually tenants in
// the old simplified model) which are now unified under one screen scoped to the
// active Organisation: members + customers + assignations.
import TeamManagement from './pages/TeamManagement';
import ClientDashboard from './pages/ClientDashboard';
import Login from './pages/Login';
import Home from './pages/Home';
import SocialMedia from './pages/SocialMedia';
import TwilioConfig from './pages/TwilioConfig';
import __Layout from './Layout';


export const PAGES = {
    "AdminAmdEngine": AdminAmdEngine,
    "AdminCallingProvider": AdminCallingProvider,
    "AdminNotifications": AdminNotifications,
    "TeamManagement": TeamManagement,
    "ClientDashboard": ClientDashboard,
    "Login": Login,
    "Home": Home,
    "SocialMedia": SocialMedia,
    "TwilioConfig": TwilioConfig,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};